import nerfetari from '../api/nerfetari';
import BaseFetch from './base';

export default class Nerfetari extends BaseFetch {
    api = nerfetari
}
